export default "__VITE_ASSET__D_Slqo6v__"